import { useState, useEffect } from 'react';
import { message } from 'antd/lib';
import { getSavedFiltersFromLocalStorage, saveFiltersInLocalStorage } from '../../../../common/helpers';

const useFilters = () => {
  const savedFilters = getSavedFiltersFromLocalStorage('garageFocusAllocationFilters');

  // Filters selected by case managers
  const [filteredGarage, setFilteredGarage] = useState(savedFilters.garage);
  const [filteredDateRange, setFilteredDateRange] = useState(savedFilters.dateRange);
  const [filteredCndType, setFilteredCndType] = useState(savedFilters.cndType);

  const clearAllFilters = () => {
    setFilteredGarage(null);
    setFilteredDateRange(null);
    setFilteredCndType(null);
    localStorage.removeItem('garageFocusAllocationFilters');
    message.success('Cleared all filters');
  };

  useEffect(
    () =>
      saveFiltersInLocalStorage('garageFocusAllocationFilters', {
        garage: filteredGarage,
        dateRange: filteredDateRange,
        cndType: filteredCndType,
      }),
    [filteredDateRange, filteredGarage, filteredCndType]
  );

  return {
    filteredGarage,
    filteredDateRange,
    filteredCndType,
    setFilteredGarage,
    setFilteredDateRange,
    setFilteredCndType,
    clearAllFilters,
  };
};

export default useFilters;
